import { render, staticRenderFns } from "./ListarSetores.vue?vue&type=template&id=76367760"
import script from "./ListarSetores.vue?vue&type=script&lang=js"
export * from "./ListarSetores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports